import { request } from './request';
import { ApiConfigs, ResponseV2 } from '../schemas/service';

const api: ApiConfigs<'registerLocation'> = {
  // 常见问题疾病目录
  registerLocation: {
    url: '/health/api/v1/ip/province',
    method: 'GET'
  }
};

const location = {
  async registerLocation(): Promise<{
    code: string;
    name: string;
    registerEnable: boolean;
    existHospital: boolean;
  }> {
    try {
      const response: ResponseV2<{
        code: string;
        name: string;
        registerEnable: boolean;
        existHospital: boolean;
      }> = await request(api.registerLocation, undefined, undefined, {
        hideToast: true
      });
      const { data } = response;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default location;
